import PullRequestForm from "@/modules/pull-requests/form";
import React from "react";
import { useParams } from "react-router-dom";
import { EvtHeader } from "components/header";

const UpdatePullRequest = () => {
  const { pullRequestId } = useParams();

  return (
    <div className="flex-1">
      <EvtHeader title="Update Pull Request" />
      <div className="max-w-md p-6">
        <PullRequestForm pullRequest={pullRequestId} />
      </div>
    </div>
  );
};

export default UpdatePullRequest;
